import { render, staticRenderFns } from "./formNote.vue?vue&type=template&id=2520b054&"
import script from "./formNote.vue?vue&type=script&lang=js&"
export * from "./formNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports